const e = {
  "side-by-side": "side-by-side",
  "side-by-side--right": "side-by-side--right",
  "side-by-side--space-between": "side-by-side--space-between",
  "side-by-side--top": "side-by-side--top",
  "side-by-side--bottom": "side-by-side--bottom",
  "side-by-side--equal-ratio": "side-by-side--equal-ratio"
};
export {
  e as default
};
